import { Outlet } from "react-router-dom";
import Sidebar, { SIDEBAR_WIDTH } from "./Sidebar";
import { Box } from "@mui/material";

export default function Layout() {
  return (
    <Box sx={{ display: "flex", minHeight: "100vh", overflowX: "hidden", bgcolor: "#F1F5F9" }}>
      <Sidebar />

      <Box
        component="main"
        sx={{
          flex: 1,
          p: { xs: 2, md: 3 },
          ml: { xs: 0, md: `${SIDEBAR_WIDTH}px` },
          minWidth: 0,
          width: "100%",
          pt: { xs: 8, md: 3 },
        }}
      >
        <Box sx={{ maxWidth: 1280, mx: "auto" }}>
          <Outlet />
        </Box>
      </Box>
    </Box>
  );
}
